// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__dH10L","faq_item":"FAQ_faq_item__KPWU4"};